import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ReceiptEmployeeState} from "@/interfaces/state";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {DebtEmployee} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ReceiptEmployeeParams} from "@/modules/receiptsexpenses/receiptemployee/params";
import {union, difference} from 'lodash';
import {listDebtEmployee, receiptEmployee} from "@/modules/receiptsexpenses/receiptemployee/services";
import {ReceiptPickingListStore} from "@/modules/receiptsexpenses/receiptpickinglist/store";

@Module({dynamic: true, name: "receiptEmployeeStore", store})
class ReceiptEmployeeModule extends VuexModule implements ReceiptEmployeeState {
    data: IdMapper<DebtEmployee> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ReceiptEmployeeParams = new ReceiptEmployeeParams();

    @Mutation
    private MAP_DEBT_EMPLOYEE(payload: any) {
        const idMapper: IdMapper<DebtEmployee> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((debt: DebtEmployee, index: number) => {
            idMapper[debt.id] = {...debt, stt: index + 1};
            return debt.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_DEBT_EMPLOYEE(payload: any) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_PARAMS_DEBT_EMPLOYEE(payload: any) {
        this.params = payload;
    }

    @Mutation
    private REMOVE_DEBT_EMPLOYEE_BY_IDS(payload: number[]) {
        this.ids = this.ids.filter((id: number) => !payload.includes(id));
        payload.forEach((id: number) => delete this.data[id]);
    }

    @Mutation
    private CLEAR_DEBT_EMPLOYEE_STORE() {
        this.ids = [];
        this.data = {};
    }

    @Action({rawError: true})
    public async listDebtEmployee(params: any) {
        const {data} = await listDebtEmployee(params);
        this.MAP_DEBT_EMPLOYEE(data);
        return data.datas;
    }

    @Action({rawError: true})
    public updateParamsDebtEmployee(payload: any) {
        this.UPDATE_PARAMS_DEBT_EMPLOYEE(payload);
    }

    @Action({rawError: true})
    public async receiptEmployee(dataReq: any) {
        const {data} = await receiptEmployee(dataReq);
        ReceiptPickingListStore.setReceiptPickingList(data.data);
        return data.data;
    }

    @Action({rawError: true})
    public clearDebtEmployeeStore() {
        this.CLEAR_DEBT_EMPLOYEE_STORE();
    }

    @Action({ rawError: true })
    public deleteDebtEmployeeByIds(payload: any) {
        this.REMOVE_DEBT_EMPLOYEE_BY_IDS(payload);
    }
}

export const ReceiptEmployeeStore = getModule(ReceiptEmployeeModule);